import PlanejamentoContraloControleLayout from '@/produto/spa/planejamento-contrato/list/PlanejamentoContraloControleLayout';

export default PlanejamentoContraloControleLayout;
